import React, { useEffect } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { isAuthenticated, companyData } from './auth';
import { routeConfig } from '../shared/common/constant';

export const PrivateRoute = ({ component, ...routeData }: any) => {
    useEffect(() => {
        document.title = routeData.name
    }, [routeData]);
    return (
        <Route {...routeData}
            render={(props) => (
                isAuthenticated() ? (
                    !companyData().isCompanyExist() && props.location.pathname !== routeConfig.createCompany.path ?
                        <Redirect to={{
                            pathname: routeConfig.createCompany.path,  //?=${props.location.pathname}
                        }} /> : component
                ) :
                    <Redirect to={{
                        pathname: '/login',
                        state: { from: props.location }
                    }} />
            )
            }
        />
    );
}

export const PublicRoute = ({ component, ...routeData }: any) => {
    useEffect(() => {
        document.title = routeData.name
    }, [routeData]);
    return (
        <Route {...routeData}
            render={({ location }) => (
                isAuthenticated() ? (
                    <Redirect
                        to={{
                            pathname: routeConfig.consigneeList.path
                        }}
                    />
                ) : (
                        component
                    ))
            }
        />
    );
}